import { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card } from "@/ui/components/primitives/card";
import { Button } from "@/ui/components/primitives/button";
import { StatusBadge } from "@/modules/shared/components/status-badge";
import { TransactionTypeBadge } from "@/modules/shared/components/transaction-type-badge";
import { mockTransactions } from "@/modules/shared/services/mock-data";

export function TransactionDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const txn = useMemo(() => mockTransactions.find((t) => t.id === id), [id]);

  if (!txn) {
    return (
      <div className="p-4 sm:p-6 lg:p-8">
        <Card className="p-6">
          <div className="flex items-center justify-between">
            <h3>Transaction not found</h3>
            <Button variant="outline" onClick={() => navigate(-1)}>Back</Button>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6 p-4 sm:p-6 lg:p-8 max-w-full overflow-x-hidden min-w-0">
      <div className="flex items-center justify-between">
        <div>
          <h1>Transaction Details</h1>
          <p className="text-muted-foreground mt-1">{txn.id}</p>
        </div>
        <Button variant="outline" onClick={() => navigate(-1)}>Back</Button>
      </div>
      <Card className="p-6 min-w-0">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 min-w-0">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Type</p>
            <TransactionTypeBadge type={txn.type} />
          </div>
          <div>
            <p className="text-sm text-muted-foreground mb-1">Status</p>
            <StatusBadge status={txn.status} />
          </div>
          <div>
            <p className="text-sm text-muted-foreground mb-1">Method</p>
            <p className="font-medium">{txn.method}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground mb-1">Customer</p>
            <p className="font-medium truncate">{txn.customer}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground mb-1">Amount</p>
            <p className="font-semibold">₹{txn.amount.toLocaleString()}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground mb-1">Net</p>
            <p className="font-semibold">₹{txn.net.toLocaleString()}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground mb-1">Date</p>
            <p className="font-medium">{txn.date} {txn.time}</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-3 mt-6">
          <Button variant="outline">Download Receipt</Button>
          <Button variant="outline">Resend Webhook</Button>
        </div>
      </Card>
    </div>
  );
}
